import PropTypes from 'prop-types'
import React from 'react'

export const RotateLeftBtn = ({item, onClick, index}) =>
  <div>
    <span className='rotate-btn' data-id={item.id} data-tmpid={item.tmpId} data-index={index} onClick={onClick}>
      &#8634;
    </span>
  </div>

RotateLeftBtn.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.shape({
    id: PropTypes.number,
    tmpId: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired
}

RotateLeftBtn.defaultProps = {
  index: 0
}
